import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'
import { Store } from '../../store'

import * as processList from './process-list'

@ngCore.Component({
  imports: [
    ds.overlay.slideout.Component,
    ds.toggleButton.Component,
    ds.tooltip.Directive,
    processList.Component,
  ],
  selector: 'atn-process-slideout',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.relay.processes.Collection} */
  private readonly _processEc = ngCore.inject(state.relay.processes.Collection)

  /** @see {@link state.relay.processes.Feature} */
  private readonly _processesFeature = ngCore.inject(
    state.relay.processes.Feature,
  )

  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link state.relay.processes.plugins.ui.Plugin} */
  public readonly processesUiPlugin = this._processEc.plugins
    .lookup(state.relay.processes.plugins.ui.Plugin)
    .get()

  /** @see {@link state.relay.processes.plugins.ui.Plugin} */
  public readonly processesPollingPlugin = this._processEc.plugins
    .lookup(state.relay.processes.plugins.polling.Plugin)
    .get()

  /**
   * TODO: Should be removed once subscriptions in API handler are implemented,
   * only purpose of this handler is to get most recent process whenever press refresh button
   */
  public refreshProcessesHandler(): void {
    this._processEc.plugins.currentListPlugin.feature.actions.load
      .from('Slideout.Header.Refresh.Button.Clicked')
      .dispatch()
  }

  /**
   * Dispatch an action to close the slideout
   */
  public closeIconClickHandler(): void {
    this._processesFeature.actions.closeSlideout
      .from('Slideout.Header.Close.Icon.Clicked')
      .dispatch()
  }
}
